import { type Form } from '@wix/ambassador-forms-v4-form/types';
import { EMPTY_VALUE } from '@wix/form-fields';

import type { FormOverrides, FormError, FormValues } from '../../types';

import { applyAllOverrides } from './all-overrides';

export function clearFieldsWhenHiddenByRule(
  form: Form,
  overrides: FormOverrides | undefined,
  currentValues: FormValues,
  newValues: FormValues,
  errors: FormError[],
) {
  const fieldCount = (form.fields ?? []).length;
  const clearedTargets: string[] = [];
  let currentForm = applyAllOverrides(form, currentValues, overrides);

  for (let i = 0; i < fieldCount; i++) {
    const newForm = applyAllOverrides(form, newValues, overrides);

    const newHiddenTargets = findHiddenTargets(newForm);
    const currentHiddenTargets = findHiddenTargets(currentForm);
    const targetsToClear = newHiddenTargets.filter(
      (item) => !currentHiddenTargets.includes(item),
    );

    if (targetsToClear.length === 0) {
      break;
    }

    currentForm = newForm;
    newValues = clearValues(newValues, targetsToClear);
    clearedTargets.push(...targetsToClear);
  }

  const newErrors = clearErrors(errors, clearedTargets);

  return { values: newValues, errors: newErrors };
}

function clearValues(values: FormValues, targetsToClear: string[]): FormValues {
  return Object.keys(values).reduce<FormValues>((result, target) => {
    if (targetsToClear.includes(target)) {
      result[target] = EMPTY_VALUE;
    } else {
      result[target] = values[target];
    }
    return result;
  }, {});
}

function clearErrors(errors: FormError[], clearedTargets: string[]) {
  return errors.filter((error) => !clearedTargets.includes(error.errorPath));
}

function findHiddenTargets(form: Form) {
  return (form.fields ?? []).reduce<string[]>((result, field) => {
    if (field.hidden && field.target) {
      result.push(field.target);
    }
    return result;
  }, []);
}
